// extracted by mini-css-extract-plugin
export var childrenContainer = "_43-0";
export var virtualScrollArea = "_43-1";